import styled from 'styled-components'

const StyledSocialProfileList = styled.div`
  display: grid;
  gap: 16px;
`

export default StyledSocialProfileList
